/* eslint-disable array-callback-return */
import React, { useState, useContext } from "react";
import { useQuery } from "react-query";
import MemberContext from "../../../context/MemberProvider";
import { getLedgerByPfNumber } from "../../../api/apiServices";
import { format } from "date-fns";
const dateFormat = "dd-MM-yyyy";

const MemberLedger = () => {
	const { mem } = useContext(MemberContext);
	const pfNumber = mem?.pfNumber;

	const {
		isLoading,
		isError,
		error,
		data: memLedger,
	} = useQuery(["memLedger", pfNumber], () => getLedgerByPfNumber(pfNumber));

	
	let ledgerData = [];
	let paymentData = [];

	memLedger?.ledger.map((ledg) => {
		let ledgData = {
			year: ledg.year,
			pf_number: ledg.pf_number,
			transaction_date: format(
				new Date(ledg.transaction_date),
				dateFormat
			),
			opening_balance: ledg.opening_balance,
			expected_total_amount: ledg.expected_total_amount,
			total_amount_paid: ledg.total_amount_paid,
			closing_balance: ledg.closing_balance,
		};
		ledgerData.push(ledgData);
	});

	// Member Payments
    memLedger?.payment.map((paymtData) => {
		let payData = {
			year: paymtData.year,
			payment_date: format(new Date(paymtData.payment_date), dateFormat),
			description: paymtData.description,
			receipt_number: paymtData.receipt_number,
			payment_amount: paymtData.payment_amount.toLocaleString(undefined, {
				minimumFractionDigits: 2,
			}),
		};
		paymentData.push(payData);
	});

	let content;
	if (isLoading) {
		content = <p>Loading Members Data...</p>;
	} else if (isError) {
		content = <p>{error.message}</p>;
	} else {
		content = (
			<>
				<div className="table-responsive lg">
					<table className="table table-borderless table-hover table-striped">
						<thead>
							<tr>
								<th style={{ textAlign: "center" }}>Year</th>
								<th style={{ textAlign: "center" }}>Date</th>
								<th style={{ textAlign: "right" }}>
									Opening Balance
								</th>
								<th style={{ textAlign: "right" }}>
									Expected Payment
								</th>
								<th style={{ textAlign: "right" }}>
									Amount Paid
								</th>
								<th style={{ textAlign: "right" }}>
									Closing Balance{" "}
								</th>
							</tr>
						</thead>
						<tbody>
							{ledgerData.map((ledger) => (
								<>
									<tr key={ledger?.id}>
										<td style={{ textAlign: "center" }}>
											{ledger?.year}
										</td>
										<td style={{ textAlign: "center" }}>
											{ledger?.transaction_date}
										</td>
										{ledger?.opening_balance < 0 ? (
											<td style={{ textAlign: "right" }}>
												(
												{(
													ledger?.opening_balance * -1
												).toLocaleString(undefined, {
													minimumFractionDigits: 2,
												})}
												){" "}
											</td>
										) : (
											<td style={{ textAlign: "right" }}>
												{ledger?.opening_balance.toLocaleString(
													undefined,
													{ minimumFractionDigits: 2 }
												)}{" "}
											</td>
										)}
										{ledger?.expected_total_amount < 0 ? (
											<td style={{ textAlign: "right" }}>
												(
												{(
													ledger?.expected_total_amount *
													-1
												).toLocaleString(undefined, {
													minimumFractionDigits: 2,
												})}
												){" "}
											</td>
										) : (
											<td style={{ textAlign: "right" }}>
												{ledger?.expected_total_amount.toLocaleString(
													undefined,
													{ minimumFractionDigits: 2 }
												)}{" "}
											</td>
										)}
										<td style={{ textAlign: "right" }}>
											{ledger?.total_amount_paid.toLocaleString(
												undefined,
												{ minimumFractionDigits: 2 }
											)}{" "}
										</td>
										{ledger?.closing_balance < 0 ? (
											<td style={{ textAlign: "right" }}>
												(
												{(
													ledger?.closing_balance * -1
												).toLocaleString(undefined, {
													minimumFractionDigits: 2,
												})}
												){" "}
											</td>
										) : (
											<td style={{ textAlign: "right" }}>
												{ledger?.closing_balance.toLocaleString(
													undefined,
													{ minimumFractionDigits: 2 }
												)}{" "}
											</td>
										)}
									</tr>
								</>
							))}
						</tbody>
					</table>
				</div>
			</>
		);
	}

	return (
		<>
			<section className="content-header">
				<h1>Member Ledger Account </h1>
			</section>
			<section className="content">
				<div className="box">
					<div className="box-body">
						<div className="panel panel-default panel-br-4">
							<div className="panel-heading">
								<div className="row">
									<div className="col-sm-12">
										<h4 className="panel-title">
											<span>Ledger Account Details</span>
										</h4>
									</div>
								</div>
							</div>
							<div className="panel-body">{content}</div>
							<div className="panel-footer"></div>
						</div>
						<div className="box-footer"></div>
					</div>
				</div>
			</section>
		</>
	);
};

export default MemberLedger;
